import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpCancelService {
  public cancelPendingRequest$: Observable<void>;
  private cancelPendingRequestSubject = new Subject<void>();

  constructor() {
    this.cancelPendingRequest$ = this.cancelPendingRequestSubject.asObservable();
  }

  cancelPendingRequest() {
    this.cancelPendingRequestSubject.next();
  }
}
